/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Image_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove image" |
*
* @param {Promo_Image_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_image_remove = /** @type {((inputs?: Promo_Image_RemoveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Image_RemoveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'image")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar imagen")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover imagem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi immagine")
	return /** @type {LocalizedString} */ ("Remove image")
});